import { connect } from 'react-redux';
import DuplicateModal from './DuplicateModal';
import { duplicateMaterialOpaque } from '../../redux/material_opaque/material_actions';

const mapStateToProps = state => ({
  isDuplicating: state.material.opaque.isDuplicating,
  errorMessage: state.material.opaque.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  duplicate: (id, name) => dispatch(duplicateMaterialOpaque(id, name)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DuplicateModal);


// WEBPACK FOOTER //
// ./src/modal/duplicate/OpaqueMaterialDuplicateModal.js